export default __webpack_public_path__ + "static/media/glossary_check_excel_it.254aa163.png";